import { bus } from './EventBus';
import type { CharacterConfig } from '../data/characters';
import { defaultCharacter } from '../data/characters';
import { STARTER_FURNITURE } from '../data/furniture';

const KEY = 'fairy-love.save.v1';

export interface PlacedFurniture {
  id: string;
  x: number;
  z: number;
  rotY: number;
}

export interface SaveData {
  version: 1;
  character: CharacterConfig;
  coins: number;
  unlockedFurniture: string[];
  placedFurniture: PlacedFurniture[];
  collectedSecrets: string[];
  lastTreatDay: string | null;
  hasPlayed: boolean;
}

function freshSave(): SaveData {
  return {
    version: 1,
    character: defaultCharacter(),
    coins: 0,
    unlockedFurniture: [...STARTER_FURNITURE],
    placedFurniture: [],
    collectedSecrets: [],
    lastTreatDay: null,
    hasPlayed: false,
  };
}

class Save {
  data: SaveData = freshSave();
  private saveTimer: number | null = null;

  hydrate(): void {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw) as Partial<SaveData>;
      if (parsed.version === 1) {
        this.data = { ...freshSave(), ...parsed } as SaveData;
      }
    } catch (err) {
      console.warn('save hydrate failed, starting fresh', err);
    }
    bus.on('save:dirty', () => this.scheduleSave());
  }

  exists(): boolean {
    return this.data.hasPlayed && localStorage.getItem(KEY) !== null;
  }

  reset(): void {
    this.data = freshSave();
    this.flush();
  }

  markPlayed(): void {
    if (!this.data.hasPlayed) {
      this.data.hasPlayed = true;
      bus.emit('save:dirty', {});
    }
  }

  private scheduleSave(): void {
    if (this.saveTimer != null) window.clearTimeout(this.saveTimer);
    this.saveTimer = window.setTimeout(() => this.flush(), 500);
  }

  flush(): void {
    try {
      localStorage.setItem(KEY, JSON.stringify(this.data));
    } catch (err) {
      console.warn('save write failed', err);
    }
  }
}

export const save = new Save();
